<div style="width: 100%">
  <mat-form-field style="width: 100%" floatLabel="always" *ngIf="!readonly">
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="selectFC" [compareWith]="selectById">
      <mat-option *ngFor="let e of _entries" [value]="e">{{
        e.name
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style="width: 100%" floatLabel="always" *ngIf="readonly">
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="selectFC" [compareWith]="selectById">
      <mat-option *ngFor="let e of _entries"
      [disabled]="_value != e.id"
      [value]="e">{{
        e.name
      }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
